import qs from "query-string";
import {
  QUERY_PARAM_KEY,
  QUERY_PARAM_KEY_VALUE,
  RECOVERED_QUERY_PARAM,
} from "./config";

export const Path = (() => {
  const isMarkedRecovered = (path) => {
    return path.includes(RECOVERED_QUERY_PARAM);
  };

  // Capture current URL that will be associated with the saved form state
  const create = () => window.location.href;

  const markRecovered = (createdPath) => {
    if (createdPath.includes(RECOVERED_QUERY_PARAM)) return createdPath;
    const parsed = qs.parseUrl(createdPath);
    const searchParams = { ...parsed.query };
    searchParams[QUERY_PARAM_KEY] = QUERY_PARAM_KEY_VALUE;
    return `${parsed.url}?${qs.stringify(searchParams)}`;
  };

  const unmarkRecovered = (createdPath) => {
    if (!isMarkedRecovered(createdPath)) return createdPath;
    const parsed = qs.parseUrl(createdPath);
    const searchParams = { ...parsed.query };
    delete searchParams[QUERY_PARAM_KEY];
    const newSearch = qs.stringify(searchParams);
    return `${parsed.url}${newSearch ? `?${newSearch}` : ""}`;
  };

  return {
    create,
    isMarkedRecovered,
    markRecovered,
    unmarkRecovered,
  };
})();

/**
 * @param {Array<{
 *    id: number;
 *    state: {
 *      path: string;
 *      data: Record<string, any>;
 *    };
 * }>} data
 * @returns {null|{path: string, data: any}}
 */
export const pickFormStateRecord = (data = []) => {
  const record = data.find(
    (item) =>
      "path" in item.state &&
      "data" in item.state &&
      Path.isMarkedRecovered(item.state.path) &&
      item.state.path.startsWith(window.location.origin),
  );

  if (record) {
    return {
      id: record.id,
      path: record.state.path,
      data: record.state.data,
    };
  }

  return null;
};
